import { HttpResult } from 'widgets-for-react'
import { NewsTeaserReference } from './newsTeasersBlockState'
import { NewsTeaserResult, PagesClient } from '../../../../../backendApi/generated'

const pagesClient = new PagesClient(window.location.origin)

// Items saved with a pageId are resolved by id, so renaming the news page does not break the teaser.
// Older items only have the filename. The backend resolves both and keeps the block order.
export const newsTeasersBlockApi = async (references: NewsTeaserReference[]): Promise<HttpResult<NewsTeaserResult[]>> => {
  const refs = references.map((reference) => reference.pageId != undefined ? `id:${reference.pageId}` : `slug:${reference.slug}`)

  try {
    const results = await pagesClient.getNewsTeasers(refs)
    return {
      kind: 'result',
      status: 200,
      // The block's text overrides the title; when it is left empty, the live page title is kept
      value: results.map((result) => {
        const blockTitle = references[result.Index]?.title
        return blockTitle?.trim() ? { ...result, Title: blockTitle } : result
      }),
    }
  } catch (error) {
    console.error(error)
    return {
      kind: 'failed',
      status: 500,
    }
  }
}
